import React, { FC } from 'react';
import cs from 'classnames';

import { reportStudioTemplateEdit } from '../../../utils/bi';
import { useTemplateContext } from '../../../context/TemplateContext';
import { useTranslation } from '@wix/wix-i18n-config';
import CornerArrowIcon from './CornerArrowIcon.svg';
import s from './EditTemplateButton.scss';

export const EditTemplateButton: FC<{ dataHook?: string }> = ({ dataHook }) => {
  const { t } = useTranslation();
  const template = useTemplateContext();
  const { isStudio2Ui } = template;

  return (
    <a
      className={cs(s.button, { [s.studio2]: isStudio2Ui })}
      href={template.editorUrl}
      target="_blank"
      onClick={() => reportStudioTemplateEdit({ template })}
      rel="noreferrer"
      data-hook={dataHook}
    >
      <div className={s.content}>
        {t('template.viewer.editTemplate')}
        {!isStudio2Ui && <CornerArrowIcon className={s.animatedIcon} />}
      </div>
    </a>
  );
};
